export const WHATSAPP = "595971155889";
export const EMAIL = "contacto@jahabrasilpe.com";
export const INSTAGRAM = "jahabrasilpe2027";

export const waLink = (text = "¡Hola JahaBrasilpe! Quiero planificar mi viaje a Brasil.") =>
  `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(text)}`;

export const NAV = [
  { id: "servicios", label: "Servicios" },
  { id: "viajes-en-auto", label: "Viajes en auto" },
  { id: "destinos", label: "Destinos" },
  { id: "como-funciona", label: "Cómo funciona" },
  { id: "testimonios", label: "Testimonios" },
  { id: "tarifas", label: "Tarifas" },
  { id: "contacto", label: "Contacto" },
];

export const TRANSPORTES = [
  { id: "En auto", label: "En auto" },
  { id: "En avión", label: "En avión" },
  { id: "Combinado (auto + avión)", label: "Combinado: auto + avión" },
];

export const DESTINOS = [
  { id: "rio", name: "Rio de Janeiro", region: "Sudeste", mode: "Auto o avión", img: "/img/rio.jpg", tags: ["Pão de Açúcar", "Cristo Redentor", "Samba"], days: "5–7 días" },
  { id: "camboriu", name: "Balneario Camboriú", region: "Sur", mode: "En auto", img: "/img/camboriu.jpg", tags: ["Playa Central", "Parque Unipraias", "Vida nocturna"], days: "4–7 días" },
  { id: "iguazu", name: "Foz do Iguaçu", region: "Sur", mode: "En auto", img: "/img/iguazu.jpg", tags: ["Cataratas", "Parque Nacional", "Punto de vuelo"], days: "2–4 días" },
  { id: "floripa", name: "Florianópolis", region: "Sur", mode: "En auto", img: "/img/floripa.jpg", tags: ["Surf", "42 playas", "Lagoa"], days: "5–8 días" },
  { id: "salvador", name: "Salvador de Bahia", region: "Nordeste", mode: "Auto + avión", img: "/img/salvador.jpg", tags: ["Pelourinho", "Cultura afro", "Gastronomía"], days: "4–6 días" },
  { id: "maceio", name: "Maceió", region: "Nordeste", mode: "Auto + avión", img: "/img/maceio.jpg", tags: ["Piscinas naturales", "Aguas turquesa", "Pajuçara"], days: "5–7 días" },
];

export const SERVICIOS = [
  { n: "01", title: "Itinerarios a tu medida", text: "Escuchamos cómo viajas y diseñamos cada día: ritmo, playas, ciudades y experiencias según tu estilo y presupuesto." },
  { n: "02", title: "Links directos a cada reserva", text: "Investigamos vuelos, hoteles, traslados y entradas y te pasamos los links directos. Vos reservás y pagás directo al proveedor." },
  { n: "03", title: "Asistencia por WhatsApp", text: "Una persona real te responde mientras armamos tu viaje. En los planes que lo incluyen, también te acompañamos durante el viaje." },
  { n: "04", title: "Cultura y sabores", text: "Rodas de samba, feijoada, acarajé y rincones que solo conocen los locales. El Brasil que no sale en los folletos." },
];

export const PASOS = [
  { n: "01", title: "Charlamos", text: "Nos cuentas qué sueñas, con quién viajas, fechas y presupuesto. Por WhatsApp o con el formulario." },
  { n: "02", title: "Diseñamos", text: "Te enviamos una propuesta de itinerario personalizada, con opciones claras y precios transparentes." },
  { n: "03", title: "Ajustamos y vos reservás", text: "Afinamos cada detalle contigo y te entregamos los links directos para que reserves y pagues con cada proveedor." },
  { n: "04", title: "Viajás tranquilo", text: "Partís con todo listo y, según tu plan, con acompañamiento por WhatsApp durante el viaje." },
];

export const TESTIMONIOS = [
  { name: "Karina", from: "Asunción", to: "Rio de Janeiro", mode: "avion", story: "Viajó a Rio de Janeiro en avión con sus amigas." },
  { name: "Anderson", from: "San Lorenzo", to: "Sao Paulo", mode: "auto", story: "Fue en auto desde San Lorenzo hasta Sao Paulo para un concierto." },
  { name: "Braulio", from: "Luque", to: "Florianópolis", mode: "auto", story: "Viajó con su grupo familiar en caravana de varios autos desde Luque hasta Florianópolis." },
  { name: "Leticia", from: "Asunción", to: "Foz do Iguaçu", mode: "auto", story: "Fue en auto desde Asunción hasta Foz do Iguaçu, visitó las Cataratas y otros atractivos de la ciudad." },
];
